import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("common", ["idToken", "accessToken", "isLogin"]),
    // 以下旧仕様。削除したいが修正漏れがあるかもしれないので、念のため残している。
    // ...mapGetters("ticketing", [
    //   "masterBookSets",
    //   "masterBookSet",
    //   "masterBooks",
    //   "masterBook",
    //   "bookGroups",
    //   "bookGroup",
    //   "book",
    //   "masterPass",
    //   "pass",
    //   "masterSheet",
    //   "sheet",
    //   "frame",
    //   "unused_frames",
    //   "used_frames",
    //   "storeCountOfMultiSheets"
    // ])
  },
};
